// Module
var code = "<p>いつもリトリモをご利用いただきありがとうございます。</p> <p>このたび、リトリモに「チャット」と「スカウト」の2つの新機能が加わりました。<br> あわせて、安心してサービスをご利用いただけるよう、利用規約を一部改定いたしました。</p>";
// Exports
module.exports = code;